<template>
  <div class="multiple-select-container">
    <multiselect
      :value="value"
      :options="options"
      :multiple="isMultiple"
      :placeholder="placeholder"
      :taggable="taggable"
      :label="label"
      :track-by="trackBy"
      :disabled="disabled"
      @tag="addNewTag"
      @select="onSelected"
      @remove="onRemoved"
      @search-change="onSearchChange"
      selectedLabel="เลือกแท็กนี้แล้ว"
      selectLabel="กด enter เพื่อเลือก"
      deselectLabel="กด enter เพื่อนำออก"
      tagPlaceholder="กด enter เพื่อสร้างแท็กใหม่"
      open-direction="bottom">
      <span slot="caret"
        class="arrow">
        <i class="fas fa-angle-down"></i>
      </span>
    </multiselect>
  </div>
</template>

<script>
import _ from 'lodash';
import Multiselect from 'vue-multiselect';

export default {
  components: { Multiselect },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    options: {
      type: Array,
      default: () => [],
    },
    isMultiple: {
      type: Boolean,
      default: true,
    },
    placeholder: {
      type: String,
      default: 'เลือกแท็ก',
    },
    taggable: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: 'name',
    },
    trackBy: {
      type: String,
      default: 'name',
    },
    addTag: {
      type: Function,
      default: () => {},
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    // showCustomLabel(selectedOption) {
    //   const option = _.find(this.options, (tag) => tag.id === selectedOption.id);
    //   return _.get(option, this.customLabel, null);
    // },
    addNewTag(selectedOption) {
      const body = { name: selectedOption };
      this.addTag(body);
    },
    onSelected(selectedOption) {
      this.$emit('onChanged', [...this.value, selectedOption]);
    },
    onRemoved(selectedOption) {
      const filterTags = _.filter(this.value, (tag) => tag.name !== selectedOption.name);
      this.$emit('onChanged', filterTags);
    },
    onSearchChange(q) {
      this.$emit('onSearch', { q });
    },
  },
};
</script>
